<template>
    <footer>
        <div class="sitemap">
            <div>
                <div>
                    <strong>{{
                        $translate('components.footer.sitemap.home')
                    }}</strong>
                </div>
                <ul>
                    <li class="p-1">
                        <RouterLink :to="{ name: 'home-shop' }">{{
                            $translate('components.footer.sitemap.location')
                        }}</RouterLink>
                    </li>
                    <li class="p-1">
                        <RouterLink :to="{ name: 'blog' }">Blog</RouterLink>
                    </li>
                </ul>
            </div>
            <div>
                <div>
                    <strong>Shop</strong>
                </div>
                <ul>
                    <li class="p-1">
                        <RouterLink
                            :to="{
                                name: 'bikes-catalog-category',
                                query: { category: 'ville' },
                            }"
                            >{{
                                $translate(
                                    'components.footer.sitemap.bikesCatalog',
                                )
                            }}</RouterLink
                        >
                    </li>
                    <li class="p-1">
                        <RouterLink
                            :to="{
                                name: 'accessories-catalog-categories',
                            }"
                            >{{
                                $translate(
                                    'components.footer.sitemap.accessoriesCatalog',
                                )
                            }}</RouterLink
                        >
                    </li>
                    <li class="p-1">
                        <RouterLink :to="{ name: 'upway-pricing-module' }">{{
                            $translate('public.shop.home.subtitles.3')
                        }}</RouterLink>
                    </li>
                </ul>
            </div>
            <div>
                <div>
                    <strong>Pro</strong>
                </div>
                <ul>
                    <li class="p-1">
                        <RouterLink :to="{ name: 'pro-employer' }">{{
                            $translate('components.footer.sitemap.employe')
                        }}</RouterLink>
                    </li>
                    <li class="p-1">
                        <RouterLink :to="{ name: 'pro-employee' }">{{
                            $translate('components.footer.sitemap.employee')
                        }}</RouterLink>
                    </li>
                    <li class="p-1">
                        <RouterLink :to="{ name: 'pro-independent' }">{{
                            $translate('components.footer.sitemap.independent')
                        }}</RouterLink>
                    </li>
                </ul>
            </div>
            <div>
                <div>
                    <strong>Repair</strong>
                </div>

                <ul>
                    <li class="p-1">
                        <RouterLink :to="{ name: 'home-repair' }">{{
                            $translate('components.footer.sitemap.repair')
                        }}</RouterLink>
                    </li>
                </ul>
            </div>
            <div>
                <div>
                    <strong>{{
                        $translate('components.footer.sitemap.others')
                    }}</strong>
                </div>
                <ul>
                    <li class="p-1">
                        <RouterLink :to="{ name: 'blog' }">{{
                            $translate('components.footer.sitemap.blog')
                        }}</RouterLink>
                    </li>
                    <li class="p-1">
                        <RouterLink :to="{ name: 'contact' }">{{
                            $translate('components.footer.sitemap.contact')
                        }}</RouterLink>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bottom">
            <div class="timetable">
                <h3>
                    {{ $translate('components.footer.timetable.title') }}
                </h3>
                <div class="time-entry">
                    <span class="day"
                        >{{
                            $translate('components.footer.timetable.days.1')
                        }}
                        :</span
                    >
                    <span class="hour">{{
                        $translate('components.footer.timetable.close')
                    }}</span>
                </div>
                <div class="time-entry">
                    <span class="day"
                        >{{
                            $translate('components.footer.timetable.days.2')
                        }}
                        :</span
                    >
                    <span class="hour">07h30 - 13h</span>
                </div>
                <div class="time-entry">
                    <span class="day"
                        >{{
                            $translate('components.footer.timetable.days.3')
                        }}
                        :</span
                    >
                    <span class="hour">09h - 18h</span>
                </div>
                <div class="time-entry">
                    <span class="day"
                        >{{
                            $translate('components.footer.timetable.days.4')
                        }}
                        :</span
                    >
                    <span class="hour">09h - 19h</span>
                </div>
                <div class="time-entry">
                    <span class="day"
                        >{{
                            $translate('components.footer.timetable.days.5')
                        }}
                        :</span
                    >
                    <span class="hour">09h - 18h</span>
                </div>
                <div class="time-entry">
                    <span class="day"
                        >{{
                            $translate('components.footer.timetable.days.6')
                        }}
                        :</span
                    >
                    <span class="hour">09h - 18h</span>
                </div>
                <div class="time-entry">
                    <span class="day"
                        >{{
                            $translate('components.footer.timetable.days.7')
                        }}
                        :</span
                    >
                    <span class="hour">{{
                        $translate('components.footer.timetable.close')
                    }}</span>
                </div>
            </div>
            <div class="contact">
                <img
                    src="/storage/assets/logos/rectangle_blanc.png"
                    alt="Kameo Bikes"
                    style="margin-top: 20px"
                />
                Quai de Rome 22, 4000 Liège
                <a href="tel:+3242907121" class="p-2 font-bold text-red"
                    >+32 4 290 71 21</a
                >
                <a href="mailto:info@kameobikes.com" class="p-2 font-bold"
                    >info@kameobikes.com</a
                >
            </div>
            <div class="follow-us">
                <h3>{{ $translate('components.footer.social.title') }}</h3>
                <div class="icons">
                    <a
                        href="https://www.facebook.com/kameobikes/?locale=fr_FR"
                        aria-label="Link towards facebook"
                    >
                        <i class="fab fa-facebook-f"></i>
                    </a>
                    <a
                        href="https://www.instagram.com/kameobikes/"
                        aria-label="Link towards instagram"
                    >
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a
                        href="https://www.linkedin.com/company/kameobikes/"
                        aria-label="Link towards linkedin"
                    >
                        <i class="fa-brands fa-linkedin-in"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="legal">
            &copy; 2025 KAMEO Bikes
            <RouterLink :to="{ name: 'CGU' }">{{
                $translate('components.footer.infos.legal.links.1')
            }}</RouterLink>
            <RouterLink :to="{ name: 'privacy-policy' }">{{
                $translate('components.footer.infos.legal.links.2')
            }}</RouterLink>
        </div>
    </footer>
</template>
<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

onMounted(() => {
    const footer = document.querySelector('footer');
    if (router.currentRoute.value.fullPath.includes('/shop')) {
        footer.style.backgroundColor = '#d60b52';
    } else if (router.currentRoute.value.fullPath.includes('/pro')) {
        footer.style.backgroundColor = '#3cb295';
    } else if (router.currentRoute.value.fullPath.includes('/repair')) {
        footer.style.backgroundColor = '#1d71d8';
    }
});
</script>
<style lang="scss" scoped>
@use '@/scss/variables' as vars;

footer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 2rem 4rem 1rem;
    color: vars.$whiteColor;
    background-color: vars.$blackColor;
    font-size: vars.$smallFontSize;
    border-top-right-radius: vars.$borderRadius;
    border-top-left-radius: vars.$borderRadius;
    box-shadow: vars.$defaultReverseShadow;
    .sitemap {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        div > div {
            width: fit-content;
            padding-left: 0.9rem;
            font-size: 0.9rem;
        }
        ul {
            li {
                a {
                    color: vars.$whiteColor;
                    text-decoration: none;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    .bottom {
        margin-top: 1.5rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        .contact {
            display: flex;
            flex-direction: column;
            font-weight: 100;
            align-items: center;
            img {
                margin-top: -1.8rem;
                width: 70%;
            }
            a {
                color: vars.$whiteColor;
                text-decoration: underline;
            }
        }
        .follow-us {
            display: flex;
            flex-direction: column;
            align-items: center;
            .icons {
                display: flex;
                gap: 0.5rem;
            }
            a {
                color: vars.$whiteColor;
                font-size: vars.$tertiaryFontSize;
                margin: 0 0.5rem;
            }
        }
        .timetable {
            font-weight: 100;
            min-width: 200px;
            .time-entry {
                display: flex;
                justify-content: space-between;
            }
            .day {
                flex: 1;
                text-align: left;
            }
            .hour {
                flex: 1;
                text-align: left;
            }
        }
    }

    .legal {
        font-weight: 100;
        text-align: center;
        margin-top: 1rem;
        a {
            color: vars.$whiteColor;
            text-decoration: none;
            margin: 0 0.5rem;
            &:hover {
                text-decoration: underline;
            }
        }
    }
}

@media screen and (max-width: vars.$mediumBreakpoint) {
    footer {
        flex-direction: column;
        padding: 2rem 4rem 1rem;
        .sitemap {
            display: none;
        }
        .bottom {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 2rem;

            .timetable {
                order: 1;
                span {
                    margin-left: 1.5rem;
                }
                .hour {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                }
            }
            .contact {
                img {
                    display: none;
                }
                order: 2;
            }
            .follow-us {
                order: 3;
            }
        }
        .legal {
            margin-top: 2rem;
        }
    }
}
</style>
